import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  DoughnutController,
  BarController,
  LineController,
  PieController,
} from "chart.js";

// Register Chart.js components (controllers and elements)
// This must be called before using any charts
// Using a side-effect import to ensure registration happens immediately
ChartJS.register(
  // Controllers (chart types) - MUST be registered
  DoughnutController,
  PieController,
  BarController,
  LineController,
  // Elements - required for rendering
  ArcElement,
  BarElement,
  PointElement,
  LineElement,
  // Scales - required for axes
  CategoryScale,
  LinearScale,
  // Plugins - optional but commonly used
  Title,
  Tooltip,
  Legend
);

export default ChartJS;

